import { Injectable } from '@angular/core';
import {Response} from '@angular/http';
import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs';
import {Phonetype} from '../../dashboard/phonetype';
import { environment } from '../../../environments/environment';


@Injectable()
export class PhonetypeService {

  constructor(private http:HttpClient) { }

  getPhoneType():Observable<Phonetype[]>{
   return this.http.get<Phonetype[]>(environment.api + 'phone_type')    
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/phonetype.service.ts